import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../utility";
import { defineState } from 'redux-localstore';

const defaultState = {
  declineStatus: [],
  error: false,
  loading: false,
  lastSync: false,
};

const initialState = defineState(defaultState)('declineStatus');

const fetchStart = (state) => {
  return updateObject(state, { error: false, loading: true, lastSync: false });
};

const fetchSuccess = (state, action) => {
  const result = action.declineStatus.length > 0 ? action.declineStatus : [];
  return updateObject(state, {
    declineStatus: result,
    error: false,
    loading: false,
    lastSync: new Date(),
  })
};

const fetchFail = (state) => {
  return updateObject(state, { error: true, loading: false, lastSync: false, declineStatus: [] });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_DECLINE_STATUS_START:
      return fetchStart(state);
    case actionTypes.FETCH_DECLINE_STATUS_SUCCESS:
      return fetchSuccess(state, action);
    case actionTypes.FETCH_DECLINE_STATUS_FAILED:
      return fetchFail(state);
    default:
      return {
        ...state,
        error: true,
        loading: false,
      };
  }
};

export default reducer;
